<template>
  <CContainer class="col-md-5 login-right">
    <CRow class="h-50">
      <CCol class="login-right__image"></CCol>
    </CRow>
    <CRow class="h-50">
      <CCol class="login-right__text">
        <h3>Galileo forms</h3>
        <h4 class="mt-3">
          Avec cet outil, suivez le parcours professionnel de vos alumni post-formation.
        </h4>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: "LoginRight",
};
</script>

<style scoped lang="scss">
.hidden-input {
  display: none;
}

.login-right {
  height: 100vh !important;
  background-color: var(--color);
  color: white;
}

.login-right__image {
  background-image: url("/img/login_right_image.jpeg");
  background-position: center;
  background-size: cover;
}

.login-right__text {
  padding: 25px 40px;

  h3 {
    font-size: 35px;
  }
}

@media only screen and (max-width: 767px) {
  .login-right {
    display: none;
  }
}
</style>
